"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const link = e.data;
    const component = e.component;
    if (!link)
        return;
    window.digitalData.component = [];
    window.digitalData.component.push({
        componentInfo: {
            componentName: component || 'NA',
        },
    });
    if (typeof window.ctConstants === 'undefined')
        return;
    const analyticsEvent = {};
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: window.ctConstants.SignUpstart,
        eventLabel: `${e.data}  ${window.location.origin}`,
        eventValue: 1,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.other,
    };
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
